// Shop Category (`shopType`) is only 'restaurant' or 'grocery'. Store Type
// (`categoryType`) holds a Shop Types tile title ("Fashion & Beauty") or a
// custom label. Mirrors the customer app's rules.

const norm = (value) => (value || "").trim().toLowerCase();

// The tile slug a store is listed under: its Store Type when that names a
// tile, otherwise its Shop Category.
export const tileOf = (restaurant, shopTypes = []) => {
  const storeType = norm(restaurant?.categoryType);
  const tile =
    storeType &&
    shopTypes.find(
      (type) => norm(type.slug) === storeType || norm(type.title) === storeType
    );
  return tile ? tile.slug : restaurant?.shopType;
};

// Fashion & Beauty stores show every product photo as a gallery
export const isFashionStore = (restaurant) =>
  /fashion/i.test(
    `${restaurant?.categoryType || ""} ${restaurant?.shopType || ""}`
  );

// Label under the store name on cards, e.g. "Fashion & Beauty"
export const storeTypeLabel = (restaurant) => {
  const value = (restaurant?.categoryType || "").trim();
  if (!value) return "";
  const label = value.replace(/[-_]+/g, " ");
  return label.charAt(0).toUpperCase() + label.slice(1);
};

// Main photo first, then the extras, without blanks or repeats
export const productImages = (food) =>
  [
    ...new Set(
      [food?.image, ...(food?.images || [])]
        .map((url) => (typeof url === "string" ? url.trim() : ""))
        .filter(Boolean)
    ),
  ];
